export default "__VITE_ASSET__BzQE3d4o__"